import React, { useContext } from 'react';
import HamQuest from '../../api/HamQuestGiver';
import { useGlobalState } from '../../stateProvider/StateProvider';
import Button from '../../forms/Button';
import Row from '../../layout/Row';
import Form from '../../forms/Form';
import Select from '../../forms/Select';
import { HSOptions } from '../../../constants/HSOptions';
import { QuestRoute } from '../../api/QuestRoutes';
import Input from '../../forms/Input';
import Checkbox from '../../forms/Checkbox';
import { addSuffix, generateId, inputDate, shortHandDate } from '../../utility/functions';
import { addCardToAccount } from '../../PaymentForm';
import Col from '../../layout/Col';
import { UserContexts } from '../../stateProvider/UsersContext';
import { useNavigate } from 'react-router-dom';
import Loading from '../../Loading';
import { accountTypes } from './User';
import GetState from '../../GetState';
import ModalFactory from '../../Modal';

export const getBD = () => {
    const currentDate = new Date();
    let dayOfMonth = currentDate.getDate();
    if (dayOfMonth > 28) dayOfMonth = 28;
    return dayOfMonth;
}

export const getBSD = (billingDay, billingStartDate) => {
    const currentBSD = new Date(billingStartDate)
    const BSD = new Date(new Date(new Date().setMonth(new Date().getMonth() + 1))).setDate(billingDay ?? getBD());

    return new Date() < currentBSD ? currentBSD : currentBSD > BSD ? currentBSD : BSD;
}

export const BillingStartDate = ({ values, setValue, editing, ...props }) => {

    const getMinMonth = () => {
        let min = 1;
        const BSDYear = parseInt(values.billingStartDate.split('-')[0]);
        const currentYear = new Date().getFullYear();
        const BD = values.billingDay;
        const today = new Date().getDate();
        if (BSDYear === currentYear) {
            min = new Date().getMonth() + (today < BD ? 1 : 2);
        }
        return min;
    }

    // console.log(values)
    return (
        <>
            <Input
                label={'Next Billing Date'}
                name='billingStartDate'
                type='date'
                required
                readOnly
            />
            {!editing &&
                <Row>
                    <Input
                        label={'Day'}
                        value={addSuffix(values.billingDay)}
                        // type='number'
                        standalone
                        disabled
                        style={{ width: '6em' }}
                    />
                    <Input
                        label={'Month'}
                        value={parseInt(values.billingStartDate.split('-')[1])}
                        type='number'
                        onChange={e => {
                            const val = values.billingStartDate.split('-');
                            val[1] = !e.target.value ? '' : e.target.value.toString().padStart(2, '0');
                            setValue('billingStartDate', val.join('-'))
                        }}
                        min={getMinMonth()}
                        max={12}
                        step={1}
                        required
                        standalone
                        style={{ width: '6em' }}
                    />
                    <Input
                        label={'Year'}
                        value={values.billingStartDate.split('-')[0]}
                        onChange={e => {
                            const val = values.billingStartDate.split('-');
                            val[0] = e.target.value;
                            setValue('billingStartDate', val.join('-'))
                        }}
                        min={new Date().getFullYear()}
                        step={1}
                        type='number'
                        standalone
                        required
                        style={{ width: '6em' }}
                    />
                </Row>
            }
        </>
    )
}

const WCSignUp = ({ child, isQuickSignup, ...props }) => {
    const {
        state: {
            active_user,
            states
        },
    } = useGlobalState();

    const context = useContext(UserContexts);

    const navigate = useNavigate();

    const { user, washClub, CC, refreshCC, refreshWC } = context || props.context

    if (!user) return <Loading />;

    const showButton = (washClub.status === 'Inactive' || washClub.status === 'CreditHold' || washClub.status === 'BillingHold' || !washClub.status);
    const currentDate = new Date();

    if (!washClub.billingDay) {
        washClub.billingDay = getBD();
    }

    const OpenUser = (id) => {
        navigate('/user/' + id, { replace: true });
    }

    const activateAccount = () => {
        const lastBilling = new Date(washClub.lastBillingDate);

        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Reactivation`,
                body: (
                    <Col>
                        <span>Reactivate {user.fullName}'s Wash Club?</span>
                        <span>Their last charge was <b>{shortHandDate(lastBilling)}</b>.</span>
                    </Col>
                ),
            },
            promise: {
                title: 'Reactivating Wash Club',
                body: `Reactivating, please wait.`,
                callback: () => HamQuest.get(QuestRoute.user.washClubReactivation(user.userId))
            },
            confirmed: {
                title: 'Success',
                body: `${user.fullName}'s successfully reactivated.`,
                type: 'success'
            },
            finally: () => refreshWC()
        })
    }

    const resignUpForm = async () => {
        ModalFactory.closeAll();

        if (child && child.warning) {
            const continueSignup = await ModalFactory.confirmation({
                title: 'User is Already subscribed',
                type: 'warning',
                closeAfter: true,
                body: <div>This User's Billing day (<b>{addSuffix(child.billingDay)}</b>) is different from parent account. Adding this user to the family plan will affect the billing dates.<br />The new billing day will be on the <b>{addSuffix(washClub.billingDay)}</b>.<br />Are you sure you wish to continue?</div>
            })

            if (!continueSignup) return;
        }
        const lastBilling = new Date(washClub.lastBillingDate);

        if (!child) {
            if (!CC.onFile || washClub.status === 'CreditHold') {
                const res = !CC.onFile ? true : await ModalFactory.confirmation({
                    title: 'Add a Card?',
                    body: 'Would you like to add a new Credit Card to this account?',
                    closeAfter: true
                })

                if (res)
                    await addCardToAccount(user.userId)
                        .then(() => refreshCC())
                        .catch(ModalFactory.catch);
            }

            if (lastBilling >= new Date().setMonth(currentDate.getMonth() - 1)) {
                activateAccount();
                return;
            }
        }

        const statusOptions = HSOptions.washClub.status
            .filter(e => e.value === 'Active' || e.value === 'EndBillingPending')
            .map(e => ({
                ...e,
                disabled: false,
            }))

        const PAYG = [];
        const id = generateId();
        ModalFactory.show({
            id,
            title: child ? `Add ${child.fullName} to Plan` : washClub.status ? 'Re-Sign Up' : 'Signup',
            body: () => {
                return (
                    <Form
                        inputs={{
                            status: '',
                            productId: washClub.productId ?? '',
                            billingDay: washClub.billingDay,
                            billToday: false,
                            billingStartDate: inputDate(getBSD(washClub.billingDay)),
                            parentAccountId: child ? user.userId : null,
                            isQuickSignup: isQuickSignup
                        }}
                        onSubmit={e => (
                            HamQuest.post(QuestRoute.user.washClubSignup(child?.userId || user.userId), { ...e })
                                .then(() => refreshWC())
                                .then(res => {
                                    ModalFactory.update({
                                        id,
                                        title: 'Success!',
                                        body: child ? `${child.fullName} has been added to ${user.fullName}'s plan.` : `${user.fullName} signed up successfully.${e.billToday ? ' Card was successfully charged.' : ''}`,
                                        buttons: [
                                            <Button
                                                label={`To ${child ? child.firstName : user.firstName}'s Account`}
                                                onClick={() => OpenUser(user.customerId)}
                                            />
                                        ],
                                    })
                                })
                                .catch(ModalFactory.catch)
                        )}
                    >
                        {({ values, setValue }) => {

                            return (
                                <>
                                    <Select
                                        label='Status'
                                        name='status'
                                        options={statusOptions}
                                        required
                                    />
                                    <Select
                                        label='Wash Club'
                                        name='productId'
                                        getOptions={QuestRoute.washClubs.clubs}
                                        buildOptions={(e) => {
                                            if (e.type === 'DailyPass') {
                                                if (user.accountType !== accountTypes.standard) {
                                                    e.disabled = true;
                                                }
                                                PAYG.push(e.productId.toString())
                                            }
                                            e.label = e.awardName;
                                            e.value = e.productId;
                                        }}
                                        callback={award => {
                                            // HamQuest.getQuery(QuestRoute.user.getBD(user.customerId), { award })
                                            //     .then(res => setValue('billingStartDate', res))
                                        }}
                                        nullable
                                        required
                                    />
                                    {child ? (
                                        <Select
                                            label='Additional Car Price'
                                            readOnly
                                            standalone
                                            getOptions={QuestRoute.washClubs.clubs}
                                            buildOptions={(e) => {
                                                e.label = e.additionalCarPrice ?? e.monthlyPrice;
                                                e.value = e.productId;
                                            }}
                                            value={values.productId}
                                            disabled
                                        />
                                    ) : (
                                        <>
                                            <Checkbox
                                                label='Charge Customer today?'
                                                name='billToday'
                                                callback={e => {
                                                    const day = e ? getBD() : washClub.billingDay
                                                    setValue('billingDay', day)

                                                    const val = values.billingStartDate.split('-');
                                                    val[2] = day.toString().padStart(2, '0');
                                                    setValue('billingStartDate', val.join('-'))
                                                }}
                                            />
                                            {!PAYG.includes(values.productId) && (
                                                <>
                                                    <Input
                                                        label='Billing Day'
                                                        name='billingDay'
                                                        disabled
                                                        required
                                                    />
                                                    <BillingStartDate values={values} setValue={setValue} />
                                                </>
                                            )}
                                        </>
                                    )}

                                </>
                            )
                        }}
                    </Form>
                )
            }
        })
    }

    if (child) return <Button onClick={resignUpForm}>{child.awardName ? 'In a Wash Club' : 'Add To Plan'}</Button>;

    if (!showButton) return null;

    return <Button onClick={resignUpForm}>Wash Club {washClub.status ? 'Re-' : ''}Sign Up</Button>;
}

export default WCSignUp;
